export default "__VITE_ASSET__iCqxQ356__"